import {useCardsPerDayQuery, useGetAllowedCoursesQuery, useUserByIdQuery} from "../../../types.d";
import {container} from "@intelingu/core/IoC/container";
import {WorkspaceStore} from "../../../stores/WorkspaceStore";
import {default as React, useEffect} from "react";
import {useObserver} from "mobx-react";
import {RoleStats} from "../stats/RoleStats";
import {Link} from "react-router-dom";
import {getShortRoleByUser} from "../../../utils/getShortRoleByUser";

interface DashboardContentProps {
    userId?: number;
    role?: string;
}

export const DashboardContent = (props: DashboardContentProps) => {
    const workspace = container.get(WorkspaceStore);
    const userId = props.userId || workspace.user.id;

    const userResponse = useUserByIdQuery({
        skip: !props.userId,
        variables: {
            id: userId
        }
    });

    let user = null;

    if (!props.userId) {
        user = workspace.user;
    } else if (userResponse.data) {
        user = userResponse.data.user;
    }

    const allowedCourses = useGetAllowedCoursesQuery({
        skip: !user,
        variables: {
            userId: props.userId ? props.userId : null
        }
    });

    useEffect(() => {
        if (!workspace.courseId && user && allowedCourses.data) {
            workspace.courseId = allowedCourses.data.allowedCourses[0].id
        }
    });

    let role;
    let cardsUrl;

    if (user) {
        role = props.role ? props.role : getShortRoleByUser(user.roles);
    }

    const cardsPerDay = useCardsPerDayQuery({
        skip: !user,
        fetchPolicy: 'network-only',
        variables: { role }
    });

    console.log(role);

    switch (role) {
        case 'MC':
            cardsUrl = props.userId ?
                `/stats-overview/mnemo-cards/user/${props.userId}` :
                '/mnemo-cards';
            break;
        case 'LP':
            cardsUrl = props.userId ?
                `/stats-overview/vocabulary-cards/user/${props.userId}` :
                '/vocabulary-cards';
            break;
    }

    return useObserver(() => {
        if (!user) {
            return <h2>Loading...</h2>
        }

        return <>
            <h1 className={'mb-5'}>{ user.name }'s Dashboard</h1>

            <div className={'mb-5'} style={{ width: '1000px' }}>
                { props.userId ? (
                    <RoleStats
                        my={false}
                        userId={props.userId}
                        role={role} />
                ) : (
                    <RoleStats
                        my={true}
                        role={role} />
                ) }
            </div>

            { cardsUrl && <Link to={cardsUrl} className={'mb-3'}>See my content</Link> }

            { cardsPerDay.data && (
                <p className={'mt-3'}>
                    Average daily edited cards: <b>{ cardsPerDay.data.cardsPerDay }</b>
                </p>
            ) }

            { allowedCourses.data && (
                <div style={{ width: 400, maxWidth: 400 }}>
                    <select className={'form-control mb-4'} value={workspace.courseId} onChange={e => {
                        workspace.courseId = Number(e.currentTarget.value);
                    }}>
                        { allowedCourses.data.allowedCourses.map(course => (
                            <option
                                key={course.id}
                                value={course.id}
                            >
                                { course.sourceLanguage.name } -> { course.translationLanguage.name }
                            </option>
                        )) }
                    </select>
                </div>
            )}
        </>
    });
};
